import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from 'src/app/services/pos-integration.service';

@Component({
  selector: 'app-ascend-defaults',
  templateUrl: './ascend-defaults.component.html',
  styleUrls: ['./ascend-defaults.component.scss']
})
export class AscendDefaultsComponent {

  @Input() partner;

  public partnerID;
  public config: any = {};
  public busy = false;
  public isWizard: boolean = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private router: Router
  ) {
  }

  ngOnInit() {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getConfig();
  }


  getConfig() {
    this.busy = true;
    this.posIntegrationService.getConfig(this.partnerID).subscribe(
      (res) => {
        this.config = res;

        console.log('config', this.config);
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
    this.busy = false;
  }
}
